var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.matches('processed'))?_c('button',{staticClass:"btn btn-outline-primary mr-2",on:{"click":function($event){_vm.confirm('Please confirm you want to clear the session')
      ? _vm.send('CLEAR')
      : null}}},[_c('fa-icon',{attrs:{"icon":"trash"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }